// See NeutralAvatar for why these are inline SVG components. This mark differs
// from the neutral one only by a slightly wider, squarer shoulder line.
export default function MaleAvatar({ className = "", title = "No profile photo", ...props }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="32" cy="32" r="32" className="fill-slate-100" />
      <circle cx="32" cy="25" r="10" className="fill-slate-400" />
      <path d="M9 58c0-10 10-17 23-17s23 7 23 17v6H9v-6Z" className="fill-slate-400" />
    </svg>
  );
}
